import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/index'
import ElementUI from 'element-ui';
import http from './api/index'
import SvgIcon from 'vue-svgicon'
import Cookies from 'js-cookie'
import './icons'

import 'element-ui/lib/theme-chalk/index.css';
import 'normalize.css'
import '@/assets/css/index.scss'
import './permission'
import * as utils from '@/utils/utils'
import {
  message
} from '@/utils/message';
import '@/utils/websocket'
import '@/icon/index'
import '@/assets/css/variables.scss'
import '@/assets/css/mixins.scss'

import preview from 'vue-photo-preview' //图片预览
import 'vue-photo-preview/dist/skin.css'//图片预览
Vue.use(preview,{
  bgOpacity:0.6
})

Vue.use(ElementUI);
Vue.use(SvgIcon, {
  tagName: 'svgicon'
})
Vue.config.productionTip = false

Vue.prototype.$http = http
Vue.prototype.$utils = utils
Vue.prototype.$cookie = Cookies
Vue.prototype.$message= message

window.eventBus = new Vue()

window.vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
